import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UPDATE_NEXT_STEP_STATUS } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useCurrentUser } from "./useCurrentUser";

export const useUpdateNextStepStatus = () => {
  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();
  const userPath = currentUser?.userPath;

  const mutation = useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["nextSteps"] });
    },
    mutationFn: ({ nextStepId, status, progress = undefined }) => {
      if (!userPath) {
        throw new Error("User path is required");
      }

      return graphQLClient.request(UPDATE_NEXT_STEP_STATUS, {
        input: {
          nextStepId: nextStepId.toString(),
          status,
          progress,
          userPath,
        },
      });
    },
  });

  return {
    updateNextStepStatus: mutation.mutate,
    updateNextStepStatusAsync: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
};
